import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/elevator';
const API_STATIC_URL = process.env.VUE_APP_ROOT_DISPLAY_STATIC;
const ROOT_URL = process.env.VUE_APP_ROOT_HOST;

const sortTableFields = ["name", "active"];
const sortDatabaseFields = ["name","active"];

const serviceName = "Elevator-Service: ";

export default class ElevatorService {

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readAllPaginatedFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, sortTableFields, sortDatabaseFields);
    await WrapperService.get(API_URL + '/page', {params : params}, serviceName, successF, errorF);
  }

  static async readFilterPaginatedFromAPI(page, size, search, sort, sortAsc, filter, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, sortTableFields, sortDatabaseFields);
    await WrapperService.post(API_URL + '/page/filter?' + params, filter, serviceName, successF, errorF);
  }

  static async loadElevatorForRegister(elevatorId, successF, errorF) {
    await WrapperService.get(API_URL + '/register/' + elevatorId, null, serviceName, successF, errorF);
  }

  static async readFromAPI(elevatorId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + elevatorId, null, serviceName, successF, errorF);
  }

  static async postToAPI(elevator, successF, errorF) {
    await WrapperService.post(API_URL, elevator, serviceName, successF, errorF);
  }

  static async putToAPI(elevator, successF, errorF) {
    await WrapperService.put(API_URL + '/' + elevator.id, elevator, serviceName, successF, errorF);
  }

  static async getElevatorsByCustomer(successF, errorF) {
    await WrapperService.get(API_URL + '/customer/elevators', null, serviceName, successF, errorF);
  }

  static async getElevatorsByElevatorCustomer(elevator, successF, errorF) {
    await WrapperService.get(API_URL + '/customer/elevators/' + elevator.id, null, serviceName, successF, errorF);
  }

  static async readAllIdName(successF, errorF) {
    await WrapperService.get(API_URL + '/allIdName', null, serviceName, successF, errorF);
  }

  static async loadClientConfiguration(elevatorId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + elevatorId + '/config', null, serviceName, successF, errorF);
  }

  static async resetClientConfiguration(elevatorId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + elevatorId + '/config/reset', null, serviceName, successF, errorF);
  }

  static async singleClientConfiguration(elevatorId, configuration, successF, errorF) {
    await WrapperService.put(API_URL + '/' + elevatorId + '/config/update/single', configuration, serviceName, successF, errorF);
  }

  static async loadPlaylistInfo(elevatorId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + elevatorId + '/playlist/info', null, serviceName, successF, errorF);
  }

  static async loadRawPlaylistInfo(elevatorId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + elevatorId + '/playlist/info/raw', null, serviceName, successF, errorF);
  }

  static async uploadBackground(elevatorId, file, applyToAll, additionalElevators, successF, errorF) {
    let formData = new FormData();
    if (elevatorId == null) {
      elevatorId = '00000000-0000-0000-0000-000000000000';
    }
    if (typeof applyToAll === 'undefined' || applyToAll === null) {
      applyToAll = false;
    }

    if (file) {
      formData.append('background', file, file.name);
    }
    formData.append('elevatorId', elevatorId);
    formData.append('applyToAll', applyToAll);
    formData.append('additionalElevators', additionalElevators);

    await WrapperService.post(API_URL + '/upload/backgroundImage', formData, serviceName, successF, errorF);
  }

  static async uploadLogo(elevatorId, file, applyToAll, additionalElevators, successF, errorF) {
    let formData = new FormData();
    if (elevatorId == null) {
      elevatorId = '00000000-0000-0000-0000-000000000000';
    }
    if (typeof applyToAll === 'undefined' || applyToAll === null) {
      applyToAll = false;
    }

    if (file) {
      formData.append('logo', file, file.name);
    }

    formData.append('elevatorId', elevatorId);
    formData.append('applyToAll', applyToAll);
    formData.append('additionalElevators', additionalElevators);

    await WrapperService.post(API_URL + '/upload/logo', formData, serviceName, successF, errorF);
  }

  static async uploadMedia(elevatorId, file, successF, errorF) {
    let formData = new FormData();
    if (elevatorId == null) {
      elevatorId = '00000000-0000-0000-0000-000000000000';
    }

    if (file) {
      formData.append('media', file, file.name);
    }
    formData.append('elevatorId', elevatorId);

    await WrapperService.post(API_URL + '/upload/media', formData, serviceName, successF, errorF);
  }

  static async getMediaByUrl(url, onSuccess) {
    await WrapperService.get(API_STATIC_URL + url, {responseType: 'blob'}, serviceName,
      response => {
        let reader = new window.FileReader()
        reader.readAsDataURL(response.data)
        reader.onload = () => {
          onSuccess(reader.result)
        }
      }
    )
  }

  static async loadMedia(id, onSuccess) {
    await WrapperService.get(API_URL + '/media/' + id + '/web', null, serviceName,
      response => {
        let url = response.data;
        ElevatorService.getMediaByUrl(url, onSuccess);
      }
    )
  }

  static async loadImage(url, onSuccess) {
    await WrapperService.get(ROOT_URL + url + '?timestamp=' + Date.now(), {responseType: 'blob'}, serviceName,
      response => {
        let reader = new window.FileReader()
        reader.readAsDataURL(response.data)
        reader.onload = () => {
          onSuccess(reader.result)
        }
      }
    )
  }

  static async sendCommandWithBody(id, body, successF, errorF) {
    await WrapperService.post(API_URL + '/command/' + id, body, serviceName, successF, errorF);
  }

  static async sendCommand(id, command, successF, errorF) {
    await WrapperService.post(API_URL + '/'+ command + '/' + id, null, serviceName, successF, errorF);
  }

  static async updatePlaylist(successF, errorF) {
    await WrapperService.post(API_URL + '/playlist/', null, serviceName, successF, errorF);
  }

  static async importSettings(id, idFrom, successF, errorF) {
    await WrapperService.get(API_URL + '/import/data/' + id + '/' + idFrom, null, serviceName, successF, errorF);
  }

  static async remove(id, successF, errorF) {
    await WrapperService.delete(API_URL + '/' + id, null, serviceName, successF, errorF);
  }

  static async getStatistic(advertId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + advertId + '/statistic', null, serviceName, successF, errorF);
  }

  static async getStatistics(paginator, filter, successF, errorF) {
    let params = createPageableParams(paginator.page,
      paginator.size,
      paginator.search,
      [paginator.sort],
      paginator.sortAsc,
      successF,
      errorF,
      sortTableFields,
      sortDatabaseFields);

    await WrapperService.post(API_URL + '/statistic?' + params, filter, serviceName, successF, errorF);
  }

  static async getDashboardData(url, successF, errorF) {
    await WrapperService.get(API_URL + '/dashboard/' + url, null, serviceName, successF, errorF);
  }

  static async getPlayouts(playoutId, successF, errorF) {
    let url = 'https://statistic.gratis-notruf.com/api/public/card/' + playoutId + '/query/json';
    await WrapperService.get(url, null, serviceName, successF, errorF);
  }

  static updateFilterForSend(origFilter) {
    let filter = Object.assign({}, origFilter);

    filter.flagActive = this.getBooleanOrNull(filter.active);
    filter.flagTest = this.getBooleanOrNull(filter.test);
    filter.flagPrivate = this.getBooleanOrNull(filter.private);
    filter.flagMails = this.getBooleanOrNull(filter.mails);
    filter.flagDemo = this.getBooleanOrNull(filter.demo);
    filter.flagCamera = this.getBooleanOrNull(filter.camera);
    filter.hasSponsoring = this.getBooleanOrNull(filter.hasSponsoring);
    filter.hasAdvertisingBonus = this.getBooleanOrNull(filter.hasAdvertisingBonus);
    filter.hasContract = this.getBooleanOrNull(filter.hasContract);
    filter.pcVisit = filter.pcvisit;
    filter.country = filter.translatedCountry;

    return filter;
  }

  static getBooleanOrNull(value) {
    return (typeof value === 'undefined') || (value === 0) || (value === null) ? null : value === 1;
  }

  static async loadImagesFromElevator(elevatorId, successF, errorF) {
    await WrapperService.get(`${API_URL}/${elevatorId}/camera/info`, null, serviceName, successF, errorF);
  }

  static async loadSelectedImage(elevatorId, successF, errorF) {
    await WrapperService.get(`${API_URL}/${elevatorId}/camera/image`, null, serviceName, successF, errorF);
  }

  static async saveByTechnical(elevator, successF, errorF) {
    await WrapperService.post(API_URL + '/register/' + elevator.id, elevator, serviceName, successF, errorF);
  }

  static async sendSnapshotRequest(elevatorId, successF, errorF) {
    await WrapperService.get(API_URL + `/snapshot/${elevatorId}`, null, serviceName, successF, errorF);
  }

  static async getRecentImage(elevatorId, snapshotTime, successF, errorF) {
    await WrapperService.post(API_URL + `/${elevatorId}/camera/image/recent`, {time: snapshotTime}, serviceName, successF, errorF);
  }

  static async loadRelatedElevator(advertId, customerId, succsessF) {
    await WrapperService.get(API_URL + '/related-elevator/' + advertId + '/' + customerId, null, serviceName, succsessF);
  }
}
